var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstadoAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.468,
    height: 46.469,
    viewBox: "0 0 46.468 46.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_942799",
    "data-name": 942799,
    transform: "translate(-0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_765",
    "data-name": "Grupo 765",
    transform: "translate(0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_764",
    "data-name": "Grupo 764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_278",
    "data-name": "Trazado 278",
    d: "M37.581,13.5a.908.908,0,0,0,.908-.908V2.723A2.726,2.726,0,0,0,35.766,0H2.73A2.726,2.726,0,0,0,.007,2.723V43.746A2.726,2.726,0,0,0,2.73,46.469H35.766a2.726,2.726,0,0,0,2.723-2.723V37.06a.908.908,0,0,0-1.815,0v6.686a.909.909,0,0,1-.908.908H2.73a.909.909,0,0,1-.908-.908V2.723a.909.909,0,0,1,.908-.908H35.766a.909.909,0,0,1,.908.908v9.87A.908.908,0,0,0,37.581,13.5Z",
    transform: "translate(-0.007)",
    fill: "#409cce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_767",
    "data-name": "Grupo 767",
    transform: "translate(10.898 4.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_766",
    "data-name": "Grupo 766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_279",
    "data-name": "Trazado 279",
    d: "M128.357,54a8.346,8.346,0,0,0-5.729,14.419.9.9,0,0,0,.1.091,8.334,8.334,0,0,0,11.262,0,.906.906,0,0,0,.1-.091A8.346,8.346,0,0,0,128.357,54Zm0,14.885a6.5,6.5,0,0,1-3.947-1.331,4.538,4.538,0,0,1,7.894,0A6.5,6.5,0,0,1,128.357,68.885Zm-1.452-6.9V61.4a1.452,1.452,0,0,1,2.9,0v.59a1.452,1.452,0,1,1-2.9,0Zm6.711,4.237a6.3,6.3,0,0,0-2.674-2.241,3.25,3.25,0,0,0,.683-2V61.4a3.267,3.267,0,1,0-6.535,0v.59a3.25,3.25,0,0,0,.683,2,6.3,6.3,0,0,0-2.674,2.241,6.535,6.535,0,1,1,10.517,0Z",
    transform: "translate(-120.007 -54)",
    fill: "#409cce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_769",
    "data-name": "Grupo 769",
    transform: "translate(18.34 39.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_768",
    "data-name": "Grupo 768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_280",
    "data-name": "Trazado 280",
    d: "M207.816,438h-4.9a.908.908,0,1,0,0,1.815h4.9a.908.908,0,1,0,0-1.815Z",
    transform: "translate(-202.007 -438)",
    fill: "#409cce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_771",
    "data-name": "Grupo 771",
    transform: "translate(10.354 34.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_770",
    "data-name": "Grupo 770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    "data-name": "Trazado 281",
    d: "M127.8,382H114.915a.908.908,0,1,0,0,1.815H127.8a.908.908,0,1,0,0-1.815Z",
    transform: "translate(-114.007 -382)",
    fill: "#409cce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_773",
    "data-name": "Grupo 773",
    transform: "translate(10.354 29.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_772",
    "data-name": "Grupo 772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    "data-name": "Trazado 282",
    d: "M127.8,326H114.915a.908.908,0,1,0,0,1.815H127.8a.908.908,0,1,0,0-1.815Z",
    transform: "translate(-114.007 -326)",
    fill: "#409cce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_775",
    "data-name": "Grupo 775",
    transform: "translate(6.476 24.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_774",
    "data-name": "Grupo 774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    "data-name": "Trazado 283",
    d: "M72.837,270.266a.907.907,0,1,0,.266.642A.915.915,0,0,0,72.837,270.266Z",
    transform: "translate(-71.287 -270)",
    fill: "#409cce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_777",
    "data-name": "Grupo 777",
    transform: "translate(6.476 29.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_776",
    "data-name": "Grupo 776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_284",
    "data-name": "Trazado 284",
    d: "M72.837,326.266a.907.907,0,1,0,.266.642A.916.916,0,0,0,72.837,326.266Z",
    transform: "translate(-71.287 -326)",
    fill: "#409cce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_779",
    "data-name": "Grupo 779",
    transform: "translate(6.476 34.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_778",
    "data-name": "Grupo 778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_285",
    "data-name": "Trazado 285",
    d: "M72.837,382.266a.907.907,0,1,0,.266.642A.916.916,0,0,0,72.837,382.266Z",
    transform: "translate(-71.287 -382)",
    fill: "#409cce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_781",
    "data-name": "Grupo 781",
    transform: "translate(10.354 24.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_780",
    "data-name": "Grupo 780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_286",
    "data-name": "Trazado 286",
    d: "M127.8,270H114.915a.908.908,0,0,0,0,1.815H127.8a.908.908,0,1,0,0-1.815Z",
    transform: "translate(-114.007 -270)",
    fill: "#409cce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_783",
    "data-name": "Grupo 783",
    transform: "translate(27.015 11.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_782",
    "data-name": "Grupo 782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_287",
    "data-name": "Trazado 287",
    d: "M315.143,125.188a3.812,3.812,0,0,0-5.207,1.4l-11.421,19.782a.909.909,0,0,0-.116.353l-.8,7.2a.908.908,0,0,0,1.44.832l5.834-4.3a.906.906,0,0,0,.248-.277l11.421-19.782A3.816,3.816,0,0,0,315.143,125.188Zm-15.514,26.872.42-3.76,2.627,1.517Zm4.37-3.576-3.458-2,9.165-15.875,3.458,2Zm10.967-19-.895,1.55-3.458-2,.895-1.55a2,2,0,0,1,3.458,2Z",
    transform: "translate(-297.589 -124.675)",
    fill: "#409cce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstadoAzul);
export default __webpack_public_path__ + "static/media/estado-azul.dfce763171f361857415d4eb87723e49.svg";
export { ForwardRef as ReactComponent };